import { Controller, Payload } from "../../controller";
import { ApplicationState } from "../../store";
import { bindActionCreators, Dispatch } from "redux";

import { Galeria ,initialValueGaleriaState, GaleriaState, GaleriaActions } from "./galeria.model"

export interface GaleriaViewProps{
    galeriaState:GaleriaState
    galeriaActions:GaleriaActions
}


class GaleriaController extends Controller<Galeria, GaleriaState, GaleriaActions> {
    constructor() {
        super(initialValueGaleriaState.row.type,initialValueGaleriaState);

        this.actionsType = {
            ...this.actionsType,
            //inserir aqui os novos actionsTypes
        };

        this.reducer.actions = {
            ...this.reducer.actions,
            //inserir aqui os novos actions
        }

        this.actionEffects = [
            ...this.actionEffects,
            //inserir aqui os novos Effects
        ]
    }

    getGaleria = async (): Promise<{status: string, row?: any, msg?: string}> => {
        //fazer uma busca no doc galeria
        //se não existir, criar um novo doc galeria com o id @GALERIA
        try {
            let resp = await this.db.getDocID("@GALERIA")
            if(resp.status === "error"){
                let newGaleria:Galeria = {
                    _id: "@GALERIA",
                    type: "galeria",
                    _attachments: {},
                    _rev: undefined,
                    created_at: new Date().toISOString(),
                    modified_at: new Date().toISOString()       
                }
                let respInsert = await this.db.createData(newGaleria)
                
                return respInsert
            }
            return resp
        } catch (error:any) {
            return {status:"error", msg:"Erro ao buscar doc galeria: "+error.message}
        }
    }

    getImagem = async (filename:string): Promise<{status: string, data?: string, msg?: string}> => {
        try {
            console.log("chamou getImagem filename", filename)
            let resp = await this.db.getAnexoDoc("@GALERIA", filename)
            if(resp.status === "error"){
                console.log("Erro ao buscar imagem: ", resp)
            }
            return resp
        } catch (error:any) {
            return {status:"error", msg:error.message}
        }
    }

    putImagem = async (file: Blob, id?:string):Promise<{status: string, data?: any, msg?: string,id?: string}> => {
        try {
            let respGaleria = await this.getGaleria()
            if(respGaleria.status === "error"){
                return {status:"error", msg:"Erro ao buscar doc galeria: "+respGaleria.msg}
            }
            let resp = await this.db.addAnexoDoc(respGaleria.row, file, id)
            console.log("putImagem resp", resp)
            return resp
        } catch (error:any) {
            confirm("Erro ao salvar imagem: " + error.message)
            return {status:"error", msg:error.message}
        }
    }

    private* novoActionEffects(actions:Payload){

    }
}

export const galeriaController = new GaleriaController()

export const mapStateToGaleriaProps = (state: ApplicationState) => ({
    galeriaState: state.galeriaState,
})

export const mapDispatchToGaleriaProps = (dispatch: Dispatch) => ({
    galeriaActions: bindActionCreators({...galeriaController.reducer.actions}, dispatch),
})